import type { CSSGridProps } from './';
// Useful subset of css grid properties
// Please expand on these if required
export const CSSGridProperties: Array<keyof CSSGridProps> = [
  'gridTemplateColumns',
  'gridTemplateRows',
  'gridTemplateAreas',
  'gridArea',
  'columnGap',
  'rowGap',
  'gap',
  'justifyItems',
  'placeItems',
  'gridColumn',
  'gridRow'
];
